import React from 'react'
import Connect from '../Components/Connect'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'


const Contact = () => {
  return (
     <>
     <Navbar/>
     <Connect/>
     <Footer/>
     </>
  )
}

export default Contact
